import React, { Component } from 'react';
import { observableSingleStore } from '../stores/single-store';
import { observableIntervalStore } from '../stores/interval-store';
import { observableChordStore } from '../stores/chord-store';
class GameOver extends Component {
  componentDidMount() {
    window.twttr.widgets.load();
  }
  render() {
    return (
      <div style={{display: 'flex', position: 'absolute', top: 0, left: 0, right:0, bottom: 0,flexDirection: 'column', justifyContent: 'center',
        alignItems: 'center'}}>
        <span style={{color: 'white', backgroundColor: '#dc3912',
          marginBottom: 30, borderRadius: 5, padding: 20}}>GAME OVER</span>
        <h1>Summary</h1>
        <div style={{display: 'flex', flexDirection: 'row',
          width: '90%', justifyContent: 'space-between'}} className="summary-container">
          <div style={{width: "33%"}}>
            <h3>Single Notes</h3>
            <div style={{textAlign: 'center'}}>{observableSingleStore.numberCorrect} / {observableSingleStore.total} ({observableSingleStore.percent}%)</div>
          </div>
          <div style={{width: "33%"}}>
            <h3>Intervals</h3>
            <div style={{textAlign: 'center'}}>{observableIntervalStore.numberCorrect} / {observableIntervalStore.total} ({observableIntervalStore.percent}%)</div>
          </div>
          <div style={{width: "33%"}}>
            <h3>Triads</h3>
            <div style={{textAlign: 'center'}}>{observableChordStore.numberCorrect} / {observableChordStore.total} ({observableChordStore.percent}%)</div>
          </div>
        </div>
        <button style={{marginTop: 40, borderRadius: 3}} onClick={this.props.store.resetGame}
          className="play-again"
          onTouchStart={this.props.store.resetGame}>Play Again</button>
        <div style={{marginTop: 40}}>
          <a href="https://twitter.com/calflegal" className="twitter-follow-button" data-show-count="false">Follow @calflegal</a>
        </div>
      </div>
    );
  }
}
export default GameOver;



// WEBPACK FOOTER //
// ./src/components/game-over.js